import { round } from "common/number-helper";
import { VisitNodePassage } from "hooks/widget-data/datapoints-api/types";
const createTooltip = (columns, x, y, value) => {
    const label = `${columns?.[x]?.label}, ${columns?.[y]?.label}`;
    return [[label, value.toString()]];
};
const init = (context, columns, visitable) => {
    context.staticData.customResult = [
        {
            columns: columns.map((y) => ({
                label: y.label ?? visitable?.data?.[0]?.measures?.[y.datapointValueLabel || ""]?.toString() ?? "",
                measureName: y.name
            })),
            matrixValues: []
        }
    ];
};
const addPoint = (context, extractValuesForColumn, visitable, xAxisValues) => {
    if (context.staticData.customResult) {
        const customResult = context.staticData.customResult?.[0];
        const currentColumn = xAxisValues?.findIndex((x) => x.dimensionValue === visitable?.dimension) ?? extractValuesForColumn;
        xAxisValues?.forEach((element, index) => {
            const value = visitable?.measures?.[element.name] ?? 0;
            const formattedValue = visitable?.measures?.[element.formattedValueName ?? element.name] ?? 0;
            customResult.matrixValues.push({ custom: { tooltip: createTooltip(customResult.columns, currentColumn, index, formattedValue) },
                value: round(value, 2),
                x: currentColumn,
                y: index });
        });
    }
};
const finalize = (args, extractValuesForColumn, selfCorelation, selfCorelationFormatted) => {
    if (args.context.staticData.customResult) {
        if (extractValuesForColumn !== -1) {
            const customResult = args.context.staticData.customResult?.[0];
            const columns = customResult.matrixValues.filter((xy) => xy.y === extractValuesForColumn)
                .map((xy) => ({ custom: { tooltip: createTooltip(customResult.columns, xy.y, xy.x, xy.custom.tooltip[0][1]) },
                value: xy.value,
                x: xy.y,
                y: xy.x }) ?? {});
            customResult.matrixValues.push({ custom: {
                    tooltip: createTooltip(customResult.columns, extractValuesForColumn, extractValuesForColumn, selfCorelationFormatted ?? "")
                },
                value: selfCorelation ?? 1,
                x: extractValuesForColumn,
                y: extractValuesForColumn }, ...columns);
        }
        args.visitable.additionalData = {};
        args.visitable.additionalData.max = Math.max(...args.context.staticData.customResult[0].matrixValues.map((x) => x.value));
        args.visitable.additionalData.min = Math.min(...args.context.staticData.customResult[0].matrixValues.map((x) => x.value));
    }
};
export const heatMap = (params) => (args) => {
    const element = args.visitable;
    const extractValuesForColumn = params.axisValues.findIndex((x) => x.name === params.extractValuesForColumn?.columnName) ?? -1;
    if (!args.context.staticData.customResult?.length && args.context.visitNodePassage === VisitNodePassage.NodeFirst) {
        init(args.context, params.axisValues ?? [], element);
    }
    else if (args.context.visitNodePassage === VisitNodePassage.Leaf) {
        addPoint(args.context, extractValuesForColumn, element, params?.axisValues);
    }
    else if (args.context.visitNodePassage === VisitNodePassage.NodeLast) {
        finalize(args, extractValuesForColumn, params.extractValuesForColumn?.selfCorrelation, params.extractValuesForColumn?.selfCorrelationFormatted);
    }
};
